import type { StatusVariant } from '@/ui/StatusBadge';

import type { StatusMedicaoSme, TipoDocumentoLiquidacao } from './tipos';

/** Rótulo e tom de cada status — os rótulos são os do protótipo. */
export const APRESENTACAO_DO_STATUS: Record<
  StatusMedicaoSme,
  { rotulo: string; variante: StatusVariant }
> = {
  RASCUNHO: { rotulo: 'Rascunho', variante: 'rascunho' },
  PROCESSADA: { rotulo: 'Processada', variante: 'pendente' },
  CALCULADA: { rotulo: 'Calculada', variante: 'processado' },
  APROVADA: { rotulo: 'Aprovada', variante: 'aprovado' },
  EMPENHADA: { rotulo: 'Empenhada', variante: 'aprovado' },
  EXPORTADA_SOF: { rotulo: 'Exportada SOF', variante: 'emitida' },
  LIQUIDADA: { rotulo: 'Liquidada', variante: 'aprovado' },
  PAGA: { rotulo: 'Paga', variante: 'pago' },
  REJEITADA: { rotulo: 'Rejeitada', variante: 'rejeitado' },
  CANCELADA: { rotulo: 'Cancelada', variante: 'cancelado' },
};

export const ROTULO_DO_DOCUMENTO: Record<TipoDocumentoLiquidacao, string> = {
  NOTA_FISCAL: 'Nota fiscal',
  RECIBO_RPA: 'Recibo de pagamento autônomo (RPA)',
  CND_FEDERAL: 'Certidão negativa federal',
  CRF_FGTS: 'Certificado de regularidade do FGTS',
  CNDT_TRABALHISTA: 'Certidão negativa trabalhista',
};

const MESES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

/** `2026-08` vira `Agosto de 2026` — como o protótipo escreve a competência. */
export function competenciaPorExtenso(competencia: string): string {
  const [ano, mes] = competencia.split('-').map(Number);
  const nome = mes ? MESES[mes - 1] : undefined;
  if (!ano || !nome) return '—';
  return `${nome.charAt(0).toUpperCase()}${nome.slice(1)} de ${ano}`;
}

/** Sem acento e sem caixa — a busca casa "aurelio" com "Aurélio". */
export function normalizar(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}
